import React, { useContext, useState } from "react";
import {
  BoldLinkB,
  BoxContainerB,
  FormContainerB,
  InputB,
  MutedLinkB,
  SubmitButtonB,
} from "./Components";
import { Marginer } from "./marginer";
import { AccountContext } from "./accountContext";
import { useSelector, useDispatch } from "react-redux";
import { customer_register } from "../../store/reducers/authReducer";
import HashLoader from "react-spinners/HashLoader";
import { RiEyeCloseFill, RiEyeFill } from "react-icons/ri";
import * as Components from "./Components";

export function SignupForm() {
  const { switchToSignin } = useContext(AccountContext);
  const { loader } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [state, setState] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const register = (e) => {
    e.preventDefault();
    dispatch(customer_register(state));
  };

  return (
    <>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <HashLoader color="#2c0246" />
        </div>
      )}
      <BoxContainerB className="sm:mx-[5%] sm:bg-white sm:p-5 sm:shadow-xl sm:rounded-3xl sm:mb-[25%] sm:pb-[8%]">
        <p className="font-semibold text-lg my-4">SIGNUP</p>
        <FormContainerB onSubmit={register}>
          <InputB
            onChange={inputHandle}
            value={state.name}
            type="text"
            id="name"
            name="name"
            placeholder="Full Name"
          />
          <InputB
            onChange={inputHandle}
            value={state.email}
            type="email"
            id="email"
            name="email"
            placeholder="Email"
          />
          <div className="flex ">
            <InputB
              onChange={inputHandle}
              value={state.password}
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Password"
            />
            <button
              type="button"
              className="block bg-[#eee] py-[13px] px-3 cursor-pointer"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
            </button>
          </div>
        </FormContainerB>
        <Marginer direction="vertical" margin={30} />
        <SubmitButtonB onClick={register}>Signup</SubmitButtonB>
        <Marginer direction="vertical" margin={20} />
        <Components.MutedLinkB href="#">
          Already have an account?
          <Components.BoldLinkB href="#" onClick={switchToSignin}>
            Signin
          </Components.BoldLinkB>
        </Components.MutedLinkB>
      </BoxContainerB>
    </>
  );
}
